export default {
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: 'red'
      }
    }
  }
}
